import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDeviceTypeHook } from '../../../shared/src/hooks/use-device-type.hook';
import { sortingTypesEnum } from '../../../shared/src/enums/sorting-types.enum';
import { SubcategoriesActionsService as ActionsService } from '../services/SubcategoriesActions.service';

export const useSortingOptionAvailability = () => {
    const { gameGridSorting } = useSelector((state) => state.app.rbcSettings);
    const { isMobile } = useDeviceTypeHook();
    const possibleSortingOptions = [
        sortingTypesEnum.NEWEST,
        sortingTypesEnum.ALPHABETIC_ASC,
        sortingTypesEnum.ALPHABETIC_DESC,
    ];

    const sortingOptionsList = useMemo(() => {
        const unifiedSortingOptions = ActionsService.unifyConfigs(gameGridSorting);
        return ActionsService.getOptionsList({
            configs: unifiedSortingOptions,
            isMobile,
        });
    }, [gameGridSorting, isMobile]);

    const checkSortingOptionAvailability = useCallback(sortingOption => ActionsService.checkOptionAvailability({
        optionToCheck: sortingOption,
        optionsList: sortingOptionsList,
    }), [sortingOptionsList]);

    const isAnySortingOptionAvailable = useMemo(() => ActionsService.isAnyOptionAvailable({
        optionsToCheck: possibleSortingOptions,
        optionsList: sortingOptionsList,
    }), [sortingOptionsList]);

    return {
        checkSortingOptionAvailability,
        isAnySortingOptionAvailable,
    };
};
